// src/pages/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom'; // Pour le lien de retour à l'accueil
import './NotFoundPage.css'; // Importe les styles

function NotFoundPage() {
  return (
    <div className="container"> {/* Conteneur global */}
      <section className="notfound-page-section">
        <div className="notfound-error-code">404</div>
        <h1 className="notfound-message">Oups ! Page non trouvée.</h1>
        <p className="notfound-suggestion">
          La page que vous recherchez semble s'être égarée dans le cyberespace.
        </p>
        <Link to="/" className="notfound-home-link">
          Retourner à l'accueil
        </Link>
      </section>
    </div>
  );
}

export default NotFoundPage;